import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"

import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"
import * as constants from "../constants"
import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import { Multiselect } from "multiselect-react-dropdown"

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeDiscountcode extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  discount_code_id: "",
                  discount_code_amount: "",
                  discount_code_number: "",
                  discount_code: "",
                  discount_code_desc: "",
                  discount_code_priority: "",
                  discount_code_title: "",
                  discount_code_date_start: "",
                  discount_code_date_end: "",
                  selectedFilterFieldinsurance: "",
                  selectedCompany: "",
                  selectedFilterCompany: "",
                  discount_code_deactive: "0",
                  orderBy: "discount_code_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newDiscountCode: true,
                  optionCompany: [],
                  optionFilterCompany: [],
                  optionFieldinsurance: [],
                  optionFilterFieldinsurance: [],
                  openDialog: false,
                  selectedFieldinsurance: [],
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleChangeAmount = (event) => {
            this.setState({ discount_code_amount: event })
      }

      handleChangeMaxForeone = (event) => {
            this.setState({ discount_code_number: event })
      }

      handleChangeMaxForall = (event) => {
            this.setState({ discount_code: event.target.value })
      }

      handleChangeDesc = (event) => {
            this.setState({ discount_code_desc: event.target.value })
      }

      handleChangePriority = (event) => {
            this.setState({ discount_code_priority: event.target.value })
      }

      handleChangeTitle = (event) => {
            this.setState({ discount_code_title: event.target.value })
      }

      setSelectedDayStart = (event) => {
            this.setState({ discount_code_date_start: event }, () => {})
      }

      setSelectedDayEnd = (event) => {
            console.log(event)
            this.setState({ discount_code_date_end: event }, () => {})
      }

      clearDeyStart = (event) => {
            this.setState({ discount_code_date_start: "" }, () => {})
      }
      clearDeyEnd = (event) => {
            this.setState({ discount_code_date_end: "" }, () => {})
      }

      handleFilterFieldinsurance = (selectedFilterFieldinsurance) => {
            this.setState({ selectedFilterFieldinsurance: selectedFilterFieldinsurance }, () => {
                  this.filterDiscountCode()
            })
      }
      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany, company_logo_url: selectedCompany.logo })
      }

      handleFilterCompany = (selectedFilterCompany) => {
            this.setState({ selectedFilterCompany: selectedFilterCompany }, () => {
                  this.filterDiscountCode()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ discount_code_deactive: "0" })
            } else {
                  this.setState({ discount_code_deactive: "1" })
            }
      }

      handleSelectRows = (row2) => {
            var jdate1 = "",
                  jdate2 = ""
            if (row2.discount_code_date_start !== "") {
                  var varmoment1 = Moment(row2.discount_code_date_start, "YYYY-M-D HH:mm:ss")
                  var date1 = new Date(parseInt(varmoment1.format("x")))
                  jdate1 = new JDate(date1)
                  jdate1 = { day: parseInt(jdate1.format("DD")), month: parseInt(jdate1.format("MM")), year: parseInt(jdate1.format("YYYY")) }
            }
            if (row2.discount_code_date_end !== "") {
                  var varmoment2 = Moment(row2.discount_code_date_end, "YYYY-M-D HH:mm:ss")
                  var date2 = new Date(parseInt(varmoment2.format("x")))
                  var jdate2 = new JDate(date2)
                  jdate2 = { day: parseInt(jdate2.format("DD")), month: parseInt(jdate2.format("MM")), year: parseInt(jdate2.format("YYYY")) }
            }

            console.log(JSON.parse(row2.discount_code_fieldinsurance_id))

            this.setState(
                  {
                        discount_code_id: row2.discount_code_id,
                        discount_code_amount: row2.discount_code_amount,
                        discount_code_number: row2.discount_code_number,
                        discount_code: row2.discount_code,
                        discount_code_desc: row2.discount_code_desc,
                        discount_code_priority: row2.discount_code_priority,
                        discount_code_title: row2.discount_code_title,
                        discount_code_date_start: jdate1,
                        discount_code_date_end: jdate2,
                        selectedCompany: JSON.parse(row2.discount_code_company_id),
                        selectedFieldinsurance: JSON.parse(row2.discount_code_fieldinsurance_id),

                        discount_code_deactive: row2.discount_code_deactive,
                        newDiscountCode: false,
                  },
                  () => {}
            )
      }

      newFuncDiscountCode = (event) => {
            this.setState({
                  discount_code_id: "",
                  discount_code_amount: "",
                  discount_code_number: "",
                  discount_code: "",
                  discount_code_desc: "",
                  discount_code_priority: "",
                  discount_code_title: "",
                  discount_code_date_start: "",
                  discount_code_date_end: "",
                  selectedFieldinsurance: [],
                  selectedCompany: [],
                  discount_code_deactive: "0",
                  newDiscountCode: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getDiscountCode()
                                    self.getoptionCompany()
                                    self.getoptionFieldinsurance()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deleteDiscountcode = () => {
            const { discount_code_id } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getDiscountCode()
                              self.newFuncDiscountCode()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_discount_code")
            fd.append("discount_code_id", discount_code_id)

            xhttp.open("POST", `${constants.BASE_URL}/discountcode`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getDiscountCode() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            console.log("fdfsds")
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discount_code")

            xhttp.open("POST", `${constants.BASE_URL}Discountcode`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه شرکت های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ company_id: arr.data[k].company_id, company_name: arr.data[k].company_name })
                                    Company1.push({ value: arr.data[k].company_id, label: arr.data[k].company_name })
                              }
                              self.setState({ optionCompany: Company, optionFilterCompany: Company1, selectedFilterCompany: Company1[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.send(fd)
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه رشته های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          fieldinsurance_id: arr.data[k].fieldinsurance_id,
                                          fieldinsurance_fa: arr.data[k].fieldinsurance_fa,
                                          fieldinsurance: arr.data[k].fieldinsurance,
                                    })
                                    Company1.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          fieldinsurance: arr.data[k].fieldinsurance,
                                    })
                              }
                              self.setState(
                                    {
                                          optionFieldinsurance: Company,
                                          optionFilterFieldinsurance: Company1,
                                          selectedFilterFieldinsurance: Company1[0],
                                    },
                                    () => {}
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }

      saveNewDiscountCode = () => {
            const {
                  discount_code_amount,
                  discount_code_number,
                  discount_code,
                  discount_code_title,
                  discount_code_desc,
                  discount_code_priority,
                  discount_code_date_start,
                  discount_code_date_end,
                  selectedFieldinsurance,
                  selectedCompany,
                  discount_code_deactive,
            } = this.state
            if (
                  selectedFieldinsurance != "" &&
                  selectedCompany != "" &&
                  discount_code_amount != "" &&
                  discount_code_number != "" &&
                  discount_code != "" &&
                  discount_code_desc != ""&&
                  discount_code_priority != ""&&
                  discount_code_title != ""
            ) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getDiscountCode()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_discount_code")
                  fd.append("discount_code_amount", discount_code_amount)
                  fd.append("discount_code_number", discount_code_number)
                  fd.append("discount_code", discount_code)
                  fd.append("discount_code_desc", discount_code_desc)
                  fd.append("discount_code_priority", discount_code_priority)
                  fd.append("discount_code_title", discount_code_title)
                  if (discount_code_date_start === "") {
                        fd.append("discount_code_date_start", "")
                  } else {
                        fd.append(
                              "discount_code_date_start",
                              Moment(
                                    JDate.toGregorian(discount_code_date_start.year, discount_code_date_start.month, discount_code_date_start.day)
                              ).format("YYYY-MM-DD h:mm:ss")
                        )
                  }
                  if (discount_code_date_end === "") {
                        fd.append("discount_code_date_end", "")
                  } else {
                        fd.append(
                              "discount_code_date_end",
                              Moment(JDate.toGregorian(discount_code_date_end.year, discount_code_date_end.month, discount_code_date_end.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  fd.append("discount_code_fieldinsurance_id", JSON.stringify(selectedFieldinsurance))
                  console.log(JSON.stringify(selectedFieldinsurance))
                  fd.append("discount_code_company_id", JSON.stringify(selectedCompany))
                  fd.append("discount_code_deactive", discount_code_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/discountcode`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changeDiscountCode = () => {
            const {
                  discount_code_id,
                  discount_code_amount,
                  discount_code_number,
                  discount_code,
                  discount_code_priority,
                  discount_code_desc,
                  discount_code_title,
                  discount_code_date_start,
                  discount_code_date_end,
                  selectedFieldinsurance,
                  selectedCompany,
                  discount_code_deactive,
            } = this.state
            if (
                  selectedFieldinsurance != "" &&
                  selectedCompany != "" &&
                  discount_code_amount != "" &&
                  discount_code_number != "" &&
                  discount_code != "" &&
                  discount_code_desc != ""&&
                  discount_code_priority != ""&&
                  discount_code_title != ""
            ) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getDiscountCode()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_discount_code")
                  fd.append("discount_code_id", discount_code_id)
                  fd.append("discount_code_amount", discount_code_amount)
                  fd.append("discount_code_number", discount_code_number)
                  fd.append("discount_code", discount_code)
                  fd.append("discount_code_desc", discount_code_desc)
                  fd.append("discount_code_priority", discount_code_priority)
                  fd.append("discount_code_title", discount_code_title)
                  if (discount_code_date_start === "") {
                        fd.append("discount_code_date_start", "")
                  } else {
                        fd.append(
                              "discount_code_date_start",
                              Moment(
                                    JDate.toGregorian(discount_code_date_start.year, discount_code_date_start.month, discount_code_date_start.day)
                              ).format("YYYY-MM-DD h:mm:ss")
                        )
                  }
                  if (discount_code_date_end === "") {
                        fd.append("discount_code_date_end", "")
                  } else {
                        fd.append(
                              "discount_code_date_end",
                              Moment(JDate.toGregorian(discount_code_date_end.year, discount_code_date_end.month, discount_code_date_end.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  fd.append("discount_code_fieldinsurance_id", JSON.stringify(selectedFieldinsurance))
                  fd.append("discount_code_company_id", JSON.stringify(selectedCompany))
                  fd.append("discount_code_deactive", discount_code_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/discountcode`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterDiscountCode = () => {
            const { selectedFilterFieldinsurance, selectedFilterCompany, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedFilterCompany.value === 0 || temparray[i].discount_code_company_id.includes(selectedFilterCompany.label)) &&
                        (selectedFilterFieldinsurance.value === 0 ||
                              temparray[i].discount_code_fieldinsurance_id.includes(selectedFilterFieldinsurance.fieldinsurance))
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      renderCustomInputEnd = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پایان"
                  value={
                        this.state.discount_code_date_end.year
                              ? this.state.discount_code_date_end.year +
                                "/" +
                                this.state.discount_code_date_end.month +
                                "/" +
                                this.state.discount_code_date_end.day
                              : ""
                  }
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyEnd}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputStart = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ شروع"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.discount_code_date_start.year
                              ? this.state.discount_code_date_start.year +
                                "/" +
                                this.state.discount_code_date_start.month +
                                "/" +
                                this.state.discount_code_date_start.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyStart}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      onSelectOptionFieldInsurance = (selectedList, selectedItem) => {
            console.log(selectedList)
            this.setState(
                  {
                        selectedFieldinsurance: selectedList,
                  },
                  () => {}
            )
            console.log(JSON.stringify(selectedList))
      }

      onRemoveOptionFieldInsurance = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFieldinsurance: selectedList,
                  },
                  () => {}
            )
            console.log(JSON.stringify(selectedList))
      }

      onSelectOptionCompany = (selectedList, selectedItem) => {
            console.log(selectedList)
            this.setState(
                  {
                        selectedCompany: selectedList,
                  },
                  () => {}
            )
            console.log(JSON.stringify(selectedList))
      }

      onRemoveOptionCompany = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedCompany: selectedList,
                  },
                  () => {}
            )
            console.log(JSON.stringify(selectedList))
      }

      render() {
            const { classes } = this.props
            const {
                  optionCompany,
                  optionFilterCompany,
                  optionFieldinsurance,
                  optionFilterFieldinsurance,
                  snackMode,
                  snackstr,
                  showSnack,
                  newDiscountCode,
                  discount_code_id,
                  discount_code_amount,
                  discount_code_number,
                  discount_code,
                  discount_code_priority,
                  discount_code_desc,
                  discount_code_title,
                  discount_code_date_start,
                  discount_code_date_end,
                  selectedFieldinsurance,
                  selectedFilterFieldinsurance,
                  selectedCompany,
                  selectedFilterCompany,
                  discount_code_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره کد تخفیف: " + discount_code_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ شروع  "}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputStart} // render a custom input
                                                                                    value={discount_code_date_start}
                                                                                    onChange={this.setSelectedDayStart}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پایان  "}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputEnd} // render a custom input
                                                                                    value={discount_code_date_end}
                                                                                    onChange={this.setSelectedDayEnd}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <Multiselect
                                                                        style={styleselect}
                                                                        options={this.state.optionFieldinsurance} // Options to display in the dropdown
                                                                        selectedValues={this.state.selectedFieldinsurance} // Preselected value to persist in dropdown
                                                                        onSelect={this.onSelectOptionFieldInsurance} // Function will trigger on select event
                                                                        onRemove={this.onRemoveOptionFieldInsurance} // Function will trigger on remove event
                                                                        displayValue="fieldinsurance_fa" // Property name to display in the dropdown options
                                                                        placeholder="انتخاب رشته"
                                                                        closeIcon="circle2"
                                                                        emptyRecordMsg="فیلد  در دسترس نیست "
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <Multiselect
                                                                        style={styleselect}
                                                                        options={this.state.optionCompany} // Options to display in the dropdown
                                                                        selectedValues={this.state.selectedCompany} // Preselected value to persist in dropdown
                                                                        onSelect={this.onSelectOptionCompany} // Function will trigger on select event
                                                                        onRemove={this.onRemoveOptionCompany} // Function will trigger on remove event
                                                                        displayValue="company_name" // Property name to display in the dropdown options
                                                                        placeholder="انتخاب شرکت"
                                                                        closeIcon="circle2"
                                                                        emptyRecordMsg="فیلد  در دسترس نیست "
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder={"مبلغ کد تخفیف "}
                                                                        handleInputt={this.handleChangeAmount}
                                                                        value={discount_code_amount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="حداکثر تعداد استفاده"
                                                                        handleInputt={this.handleChangeMaxForeone}
                                                                        value={discount_code_number}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="کد تخفیف"
                                                                        handleInputt={this.handleChangeMaxForall}
                                                                        value={discount_code}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="عنوان تخفیف"
                                                                        handleInputt={this.handleChangeTitle}
                                                                        value={discount_code_title}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="اولویت"
                                                                        handleInputt={this.handleChangePriority}
                                                                        value={discount_code_priority}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات"
                                                                        handleInputt={this.handleChangeDesc}
                                                                        value={discount_code_desc}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={discount_code_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت کد تخفیف"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newDiscountCode ? (
                                                                        <Button variant="outlined" color="primary" onClick={this.saveNewDiscountCode}>
                                                                              {"ثبت کد تخفیف جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newFuncDiscountCode}
                                                                              >
                                                                                    {"کد تخفیف جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changeDiscountCode}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف کد تخفیف"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">رشته بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFilterFieldinsurance}
                                                                              onChange={this.handleFilterFieldinsurance}
                                                                              options={optionFilterFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedFilterCompany}
                                                                              onChange={this.handleFilterCompany}
                                                                              options={optionFilterCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"discount_code_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "discount_code_id" ? order : false}
                                                                              >
                                                                                    {" آی دی تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "discount_code_id"}
                                                                                          direction={orderBy === "discount_code_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("discount_code_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"discount_code_amount"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "discount_code_amount"}
                                                                                          direction={
                                                                                                orderBy === "discount_code_amount" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("discount_code_amount")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"discount_code_number"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"حداکثر تعداد "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "discount_code_number"}
                                                                                          direction={
                                                                                                orderBy === "discount_code_number" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("discount_code_number")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"discount_code_cnt"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" تعداد استفاده "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "discount_code_cnt"}
                                                                                          direction={orderBy === "discount_code_cnt" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("discount_code_cnt")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                    key={"discount_code_sum"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" میزان استفاده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "discount_code_sum"}
                                                                                          direction={orderBy === "discount_code_sum" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("discount_code_sum")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"discount_code_priority"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"اولویت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "discount_code_priority"}
                                                                                          direction={orderBy === "discount_code_priority" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("discount_code_priority")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                    key={"discount_code_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت کد تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "discount_code_deactive"}
                                                                                          direction={
                                                                                                orderBy === "discount_code_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("discount_code_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["discount_code_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"discount_code_id"} align={"center"}>
                                                                                                      {row["discount_code_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell align={"center"}>
                                                                                                      {row["discount_code_amount"]}
                                                                                                </TableCell>

                                                                                                <TableCell align={"center"}>
                                                                                                      {row["discount_code_number"]}
                                                                                                </TableCell>

                                                                                                <TableCell align={"center"}>
                                                                                                      {row["discount_code_cnt"]}
                                                                                                </TableCell>

                                                                                                <TableCell align={"center"}>
                                                                                                      {row["discount_code_sum"]}
                                                                                                </TableCell>

                                                                                                <TableCell align={"center"}>
                                                                                                      {row["discount_code_priority"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"discount_code_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["discount_code_deactive"] === "1" ||
                                                                                                      row["discount_code_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید کد تخفیف را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteDiscountcode} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeDiscountcode)
